import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import DepartmentConfig from "@/config/department";
import { hasPermission } from "@/lib/permissionUtil";
import { getStorage } from "@/lib/webStorage";
import RecentSchedule from './RecentSchedule';
import OfficeSchedule from './OfficeSchedule';
import StudentSchedule from './StudentSchedule';
import MediaShare from './MediaShare';
import DocumentShare from './DocumentShare';
import "./index.less";

const { getDepartmentInfo } = DepartmentConfig;

function Home() {
  const [departmentArray, setDepartmentArray]: any = useState([]);
  const roleId = +getStorage("roleId");

  useEffect(() => {
    getDepartmentInfo().then((res: any) => {
      const departmentArray = res?.value ?? {};
      setDepartmentArray(departmentArray);
    });
  }, []);

  return (
    <>
      <Row className="home" gutter={[24, 24]}>
        <Col span={14}>
          <Row gutter={[24, 24]}>
            {hasPermission('HOME_RECENT_SCHEDULE') &&
              <Col span={24}>
                <RecentSchedule departmentArray={departmentArray} roleId={roleId} />
              </Col>
            }

            {hasPermission('HOME_OFFICE_SCHEDULE') &&
              <Col span={24}>
                <OfficeSchedule departmentArray={departmentArray} roleId={roleId} />
              </Col>
            }

            {hasPermission('HOME_STUDENT_SCHEDULE') &&
              <Col span={24}>
                <StudentSchedule />
              </Col>
            }
          </Row>
        </Col>

        <Col span={10}>
          <Row gutter={[24, 26]}>
            {hasPermission('HOME_MEDIA_SHARE') &&
              <Col span={24}>
                <MediaShare />
              </Col>
            }

            {hasPermission('HOME_DOCUMENT_SHARE') &&
              <Col span={24}>
                <DocumentShare />
              </Col>
            }
          </Row>
        </Col>
      </Row>
    </>
  )
};

export default Home;